import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';

// Create Payslip
export const createPayslip = createAsyncThunk(
    'payslip/create',
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.post('/payslips', data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create payslip');
        }
    }
);

// Fetch All Payslips
export const fetchPayslips = createAsyncThunk(
    'payslip/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.get('/payslips');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch payslips');
        }
    }
);

// Fetch Payslip by ID
export const fetchPayslipById = createAsyncThunk(
    'payslip/fetchById',
    async (payslipId: number, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.get(`/payslips/${payslipId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch payslip');
        }
    }
);

// Update Payslip
export const updatePayslip = createAsyncThunk(
    'payslip/update',
    async ({ id, ...data }: any & { id: number }, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.put(`/payslips/${id}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update payslip');
        }
    }
);

// Delete Payslip
export const deletePayslip = createAsyncThunk(
    'payslip/delete',
    async (payslipId: number, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.delete(`/payslips/${payslipId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete payslip');
        }
    },
);

export const fetchPayslipsByEmployeeId = createAsyncThunk(
    'payslip/fetchByEmployeeId',
    async (employee_id: number, { rejectWithValue }) => {
        try {
            const response = await payrollServiceApiInstance.get(`/employee/payslips/${employee_id}`);
            return response.data; // Response should now include employee-related fields (name, picture, etc.)
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch payslips');
        }
    }
);
